import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export function fascicleAutoFormFields(
  translate: TranslateService,
  templateOptions: { label: string; value: string }[]
): FormlyFieldConfig[] {
  return [
    {
      key: 'name',
      type: 'input',
      className: 'mb-2 block',
      props: {
        label: translate.instant('FASCICLE.NAME'),
        required: true,
      },
    },
    {
      key: 'defaultTemplate',
      type: 'select',
      className: 'mb-2 block',
      props: {
        label: translate.instant('FASCICLE.TEMPLATES'),
        required: true,
        options: templateOptions,
      },
    },
  ];
}
